module.exports = __webpack_public_path__ + "static/media/w (33).aa3afbe7.jpg";